import React from "react"
import { Col, Accordion } from "react-bootstrap"

const Prices1 = () => {
  return (
    <Accordion>
      <Col className="pb-2">
        <Accordion.Item eventKey="300">
          <Accordion.Header>What is your refund policy?</Accordion.Header>
          <Accordion.Body>
            We have a 100% satisfaction guarantee. If for any reason, you're not
            satisfied with your purchase, simply let us know within 30 days and
            we'll be happy to issue you a full refund.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="301">
          <Accordion.Header>How do I get billed?</Accordion.Header>
          <Accordion.Body>
            We Count your current Monthly Orders and bill you accordingly.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="302">
          <Accordion.Header>Can I cancel at anytime?</Accordion.Header>
          <Accordion.Body>
            Yes, there are no long-term commitments required for any plan.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="303">
          <Accordion.Header>
            Will my subscription renew automatically?
          </Accordion.Header>
          <Accordion.Body>
            Yes, You will receive your monthly invoice on the first week of the
            next month.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="304">
          <Accordion.Header>
            How do I get billed if I joined in the middle of the month?
          </Accordion.Header>
          <Accordion.Body>
            The date you joined doesn't matter. What matters is your total order
            numbers on the month you joined. Here is a weird example, if you
            joined on the 30th and you had 1000 orders, you will get billed
            $24.99, if on the next month you had 999 orders, that month will be
            free.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="305">
          <Accordion.Header>Do Canceled Orders Count?</Accordion.Header>
          <Accordion.Body>
            No, The system will count all orders that were not canceled and it
            does it on the 3rd day of each next month just in case there were
            pending orders that changed to canceled status.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="306">
          <Accordion.Header>Do Refunded Orders Count?</Accordion.Header>
          <Accordion.Body>
            Yes, Usually refunded orders takes time until the customer receives
            the item, tests it, then returns it.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="307">
          <Accordion.Header>
            What payment methods do you accept?
          </Accordion.Header>
          <Accordion.Body>
            We accept all major credit cards! For Enterprise orders (above 50k
            orders) we also accept bank transfers.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
    </Accordion>
  )
}

export default Prices1
